import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';

import Tooltip from '../Tooltip';

type Props = {
  isSubscribed: boolean;
  onClickSubscribe?: () => Promise<void>;
};

const SubscribeBell: React.FC<Props> = ({ isSubscribed, onClickSubscribe }) => {
  const { t } = useTranslation('common');
  const linkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <Button
        ref={linkRef}
        disabled={isSubscribed}
        hideLabel
        icon={
          isSubscribed ? 'ic_notification_active' : 'ic_notification_outline'
        }
        label={
          isSubscribed
            ? t('tooltips.subscribed')
            : t('tooltips.subscribeToArtist')
        }
        onClick={() => onClickSubscribe?.()}
        size="sm"
        variant={isSubscribed ? 'positive' : 'tertiary'}
      />
      <Tooltip parentRef={linkRef} selectionRef={linkRef}>
        {isSubscribed
          ? t('tooltips.subscribed')
          : t('tooltips.subscribeToArtist')}
      </Tooltip>
    </>
  );
};

export default SubscribeBell;
